// extracted by mini-css-extract-plugin
export var avatarContainer = "_4n-1";
export var largeAvatarContainer = "_4n-2";
export var smallAvatarContainer = "_4n-0";